var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.457665 0.457665C1.06785 -0.152555 2.05717 -0.152555 2.66735 0.457665L12.5 10.2903L22.3327 0.457665C22.9429 -0.152555 23.9322 -0.152555 24.5424 0.457665C25.1525 1.06785 25.1525 2.05717 24.5424 2.66735L13.6049 13.6049C12.9947 14.2151 12.0054 14.2151 11.3952 13.6049L0.457665 2.66735C-0.152555 2.05717 -0.152555 1.06785 0.457665 0.457665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown1Icon);
export default __webpack_public_path__ + "static/media/chevron-down-1-icon.3a9b446a605fa70df15f8633710ef59b.svg";
export { ForwardRef as ReactComponent };